import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Tooltip } from '@mui/material';
import Grid from '@mui/material/Grid';
import { env } from 'utils/env';
import CardContentComponent from './CardContentComponent';
import { Typography } from '@totalsoft/rocket-ui';
import { DashboardCard } from './DashboardStyles';

export const DashboardCardComponent = ({ menu }) => {
  const { t } = useTranslation();
  const path = menu.isExternal ? env[menu.path] : menu.path;

  return (
    <Grid item xs={12} sm={6} lg={4} xl={3}>
      <DashboardCard
        icon={menu.icon}
        iconColor={menu.iconColor}
        title={<CardContentComponent path={path} isExternal={menu.isExternal} text={menu.text}></CardContentComponent>}
      >
        <Tooltip title={t(menu.footer)}>
          <span>
            <Typography variant='body2' whiteSpace='nowrap' textOverflow='ellipsis' width='100%' overflow='hidden'>
              {t(menu.footer)}
            </Typography>
          </span>
        </Tooltip>
      </DashboardCard>
    </Grid>
  );
};

DashboardCardComponent.propTypes = {
  menu: PropTypes.object
};

export default DashboardCardComponent;
